import { NutritionRecommendation } from '@app/core/models';
import { AllowanceCalculatorBlocks } from '@app/shared/utils/enums/allowance-calculator-blocks.enum';
import { createAction, props } from '@ngrx/store';
/**
 * Actions dispatched to retrieve recommended products
 */
export const getAllowanceRecommendation = createAction(
  '[Allowance] Get Recommendation',
  props<{
    productPacks?: { productId: string; packId: string }[];
    manualWetRation?: number;
    manualTreatsRation?: number;
    allocation?: number;
    ignoreCurrentAllocation?: boolean;
  }>(),
);
export const getAllowanceRecommendationSuccess = createAction(
  '[Allowance] Get Recommendation Success',
  props<{ recommendation: NutritionRecommendation }>(),
);

export const getAllowanceRecommendationFail = createAction('[Allowance] Get Recommendation Fail', props<{ error: string }>());
/**
 * Action dispatched to get all wet quatity
 */
export const getAllowanceRecommendationAllWetQuantity = createAction(
  '[Allowance] Get Recommendation wet quantity',
  props<{ allocation: number; ignoreCurrentAllocation?: boolean }>(),
);

export const getAllWetRecommendationQuantitySuccess = createAction(
  '[Allowance] Get Recommendation wet quantity success',
  props<{ allWetQuantityPerDay?: number | null }>(),
);

export const getAllowanceRecommendationAllTreatsQuantity = createAction(
  '[Allowance] Get Recommendation treats quantity',
  props<{ allocation: number; ignoreCurrentAllocation?: boolean }>(),
);

export const getAllTreatsRecommendationQuantitySuccess = createAction(
  '[Allowance] Get Recommendation treats quantity success',
  props<{ allTreatsQuantityPerDay?: number | null }>(),
);

/**
 * Action dispatched to set default allowance recommendation when triggered without manual values
 */
export const setAllowanceDefaultRecommendation = createAction(
  '[Allowance] Set Default Recommendation',
  props<{ recommendation: NutritionRecommendation }>(),
);

/**
 * Action dispatched to set allowance recommendation for pet in gestation
 */
export const setAllowanceRecommendationForGestation = createAction(
  '[Allowance] Set Recommendation for Gestation',
  props<{ recommendation: NutritionRecommendation[] }>(),
);

export const setAllowanceLoadingRecommendation = createAction(
  '[Allowance] Set Allowance Loading Recommendation',
  props<{ value: boolean }>(),
);

export const setAllowanceCurrentBlockEditing = createAction(
  '[Allowance] Set Allowance Current Block Editing',
  props<{ block: AllowanceCalculatorBlocks; value: boolean }>(),
);
